import { NgModule, InjectionToken } from '@angular/core';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { LambdaClientConfig } from './models';
import { Helper } from './helper';

export const LAMBDA_CLIENT_CONFIG = new InjectionToken<LambdaClientConfig>('LAMBDA_CLIENT_CONFIG');
@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG
    })
  ],
})
export class TsSditDataModule {
  static forRoot(config: LambdaClientConfig) {
    return {
      ngModule: TsSditDataModule,
      providers: [
        { provide: LAMBDA_CLIENT_CONFIG, useValue: config },
        Helper
      ]
    };
  }
}
